import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PubGuideUserComponent } from './container/pub-guide-user.component';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { GuideTabComponent } from './components/guide-tab/guide-tab.component';
import { ManualTabComponent } from './components/manual-tab/manual-tab.component';
import { AccesibilityTabComponent } from './components/accesibility-tab/accesibility-tab.component';
import { MatTabsModule } from '@angular/material/tabs';

const PubGuideRoute: Routes = [{ path: '', component: PubGuideUserComponent }];

@NgModule({
  declarations: [
    PubGuideUserComponent,
    GuideTabComponent,
    ManualTabComponent,
    AccesibilityTabComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatTableModule,
    MatTabsModule,
    RouterModule.forChild(PubGuideRoute),
  ],
})
/**
 * Represents the module for the PubGuideUser component.
 */
export class PubGuideUserModule {}
